import React from 'react'
import AdmEmployeeSearch from '../../components/AdminTabs/AdminEmployeeSearch/AdmEmployeeSearch'

const EmployeeSearch = () => {
  return (
    <div>
      <AdmEmployeeSearch />
    </div>
  )
}

export default EmployeeSearch
